import { getCategoryListMap } from "src/consumer/helpers/courseCardHelper";

export function getDataForPlanDayItem(planEventData, setupData) {

    let eventData = {}
    let categoryList = getCategoryListMap(setupData);
    eventData.day = planEventData?.day;
    eventData.id = planEventData?.id;
    eventData.itemId = planEventData?.itemId;
    eventData.mandatory = planEventData?.mandatory;
    eventData.planDuration = planEventData?.planDuration;
    eventData.planId = planEventData?.planId;
    eventData.releaseAfter = planEventData?.releaseAfter;
    eventData.status = planEventData?.status;
    eventData.tags = planEventData?.tags;
    eventData.itemType = planEventData?.type;

    if (planEventData?.type === "episode") {
        eventData.title = planEventData?.onlineCourse?.episode?.title;
        eventData.category = categoryList ? (categoryList?.get(planEventData?.onlineCourse?.episode?.category[0])?.singleTitle || categoryList?.get(planEventData?.onlineCourse?.episode?.category[0])?.name) : ''
        eventData.description = planEventData?.onlineCourse?.episode?.longDesc
        eventData.mainData = {
            "course": {
                "id": planEventData?.onlineCourse?.course?.id || "",
                "title": planEventData?.onlineCourse?.episode?.title || "",
                "longDesc": planEventData?.onlineCourse?.episode?.longDesc,
                "courseType": planEventData?.onlineCourse?.episode?.sessionType,
                "categoryId": [
                    planEventData?.onlineCourse?.episode?.category?.[0]
                ],
                "courseCategory": categoryList ? (categoryList?.get(planEventData?.onlineCourse?.episode?.category[0])?.singleTitle || categoryList?.get(planEventData?.onlineCourse?.episode?.category[0])?.name) : '',
                "sessions": [
                    {
                        ...planEventData?.onlineCourse?.episode
                    }
                ]
            },
            "teacher": {
                firstName: planEventData?.onlineCourse?.teachers?.[0]?.firstName || "",
                profilePicId: planEventData?.onlineCourse?.teachers?.[0]?.profilePicId || ""
            }
        };
        eventData.imgId = planEventData?.onlineCourse?.episode?.coverIcon || planEventData?.onlineCourse?.episode?.coverImage || "";
        eventData.durationDetail = planEventData?.onlineCourse?.episode?.duration;
    }

    return eventData;

}

export const getPlanDurationText = (numberOfDays) => {
    if (numberOfDays % 7 === 0) {               // if divisible by 7, so we can say weeks
        if (numberOfDays / 7 === 1) {
            return `${numberOfDays / 7} week`
        } else {
            return `${numberOfDays / 7} weeks`
        }
    } else {                                    // if not divisible by 7, so we can say days
        if (numberOfDays === 1) {
            return `${numberOfDays} day`
        } else {
            return `${numberOfDays} days`
        }
    }
}